import { render, staticRenderFns } from "./TourGroupAccommodationUpdate.vue?vue&type=template&id=22d54173&"
import script from "./TourGroupAccommodationUpdate.vue?vue&type=script&lang=js&"
export * from "./TourGroupAccommodationUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports